import { toUpper } from 'lodash';
import React, { useEffect, useState } from 'react';
import Checkbox from '../abs-filter-components/filters/CheckboxBuilder';
import FilterValueLabel from '../abs-filter-components/filters/FilterValueLabelAbs';

const FilterComponents = ({
  index,
  activeFilterIndex,
  filterType,
  updateValueToFilters,
  appliedFilters,
  currentCategory,
}) => {
  const [isFilterCollapsed, SetIsFilterCollapsed] = useState(true);
  const [isChecked, SetIsChecked] = useState(false);
  // let classNames = 'abs-filter-card active height-nun';
  let classNames = 'abs-filter-card height-nun';
  useEffect(() => {
    const isPresent =
      appliedFilters &&
      appliedFilters.find(each => each.name === filterType.attr);
    if (isPresent === undefined) {
      // SetIsChecked(false);
    } else {
      // SetIsChecked(true);
    }
    // console.log(isPresent,'isPresent',appliedFilters)
  }, [appliedFilters]);
  useEffect(() => {
    SetIsFilterCollapsed(true);
  }, [currentCategory]);
  const handleFilterCollapse = () => {
    let currentFilterState = !isFilterCollapsed;
    SetIsFilterCollapsed(currentFilterState);
  };
  return (
    <>
      <div className={isFilterCollapsed ? classNames : `${classNames} active`}>
        <label
          className={
            isChecked ? 'active-nav abs-filter-name' : 'abs-filter-name'
          }
          onClick={handleFilterCollapse}
        >
          {filterType.name}
          <span>
            <i className={isFilterCollapsed ? 'arrow down' : 'arrow up'}></i>
          </span>
        </label>

        <div
          className={
            isFilterCollapsed
              ? 'hidevalue abs-filter-values'
              : 'showvalue abs-filter-values'
          }
        >
          {!isFilterCollapsed ? (
            parseInt(filterType.valuesPerRow) == 1 ? (
              filterType.values.map(filterValue => {
                let displayNameText =
                  filterValue.meta.display_value === 'block'
                    ? filterValue.value
                    : filterValue.meta.display_value;
                return (
                  <label
                    className="abs-filter-singlevalue"
                    key={filterValue.value}
                  >
                    <Checkbox
                      name={filterValue.value}
                      updateValueToFilters={updateValueToFilters}
                      filterType={filterType}
                      filterValue={filterValue}
                      appliedFilters={appliedFilters}
                    />
                    <div>
                      {toUpper(
                        displayNameText ? displayNameText : filterValue.value
                      )}{' '}
                      {filterValue.count != undefined
                        ? `(${filterValue.count})`
                        : null}
                    </div>
                  </label>
                );
              })
            ) : (
              <div className="abs-filter-label-box">
                {filterType.values.map(filterValue => {
                  return (
                    <FilterValueLabel
                      key={filterValue.value}
                      filterType={filterType}
                      filterValue={filterValue}
                      updateValueToFilters={updateValueToFilters}
                      isApplied={filterValue.checked}
                      appliedFilters={appliedFilters}
                    />
                  );
                })}
              </div>
            )
          ) : null}
        </div>
      </div>
    </>
  );
};

export default FilterComponents;

{
  /* <div className="left-sidebar" id="left-bar">
        {
          <h5>
            Narrow Choices{' '}
            <i className="closelefbar" onClick={handleApplyClose}>
              <svg
                height="329pt"
                viewBox="0 0 329.26933 329"
                width="329pt"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0" />
              </svg>
            </i>
          </h5>
        }

        <div className="leftwrap">
          {FilterData != undefined &&
            FilterData.length > 0 &&
            FilterData.map(filterType => {
              return (
                <Filter
                  key={filterType.attr}
                  filterType={filterType}
                  appliedFilters={appliedFilters}
                  updateValueToFilters={updateValueToFilters}
                  handleApplyClick={handleApplyClick}
                  checkprefiltered={checkprefiltered}
                  applyfiltered={applyfiltered}
                  setApplySelectedFilters={setApplySelectedFilters}
                  applyFilterWise={applyFilterWise}
                  removeFil={removeFil}
                  setRemoveFil={setRemoveFil}
                />
              );
            })}
        </div> 
      </div> */
}
